import React from 'react';

const FindAGasContractor = () => {
    return (
        <div className="panel panel-default infobox">
            <div className="panel-body">
                <h4 className="text-primary">Find a gas contractor</h4>
                <p>Looking for a licensed contractor to install your new gas appliances? Find one in your area with our directory.  </p>
                <i className="fa fa-angle-right icon-widget-gas" />
                <a id="link3"
                    href="http://www.fortisbc.com/FindAContractor/Pages/default.aspx"
                  className="link-widget box-link" target="_blank"> Go to find a contractor</a>
            </div>
        </div>
    );
};

export default FindAGasContractor;



